import request from '@/utils/request'
export const baseURL = process.env.VUE_APP_BASE_API

export const CGGLISISSUESAPI = {
  // 采购管理工单创建
  addIssue: (data: object, params: any) => {
    return request({
      url: baseURL + 'cggl/ticket/add',
      method: 'post',
      data,
      params
    })
  },
  // 服务保障工单编辑
  editIssue: (data: object) => {
    return request({
      url: baseURL + 'cggl/ticket/edit',
      method: 'post',
      data
    })
  },
  // 手动录入工单
  manualAdd: (data: object, params: any) => {
    return request({
      url: baseURL + 'cggl/ticket/manualAdd',
      method: 'post',
      data,
      params
    })
  },
  // 手动录入工单编辑
  manualEdit: (data: object, params: any) => {
    return request({
      url: baseURL + 'cggl/ticket/manualEdit',
      method: 'post',
      data,
      params
    })
  }
}

export const CGGLISORDERAPI = {
  // 我创建的工单列表
  getMyCreatedOrderList: (params: any) => {
    return request({
      url: baseURL + 'cggl/my/list',
      method: 'get',
      params
    })
  },
  // 超级管理员-获取所有工单
  getAllAdminOrderList: (params: any) => {
    return request({
      url: baseURL + 'cggl/ticket/all/list',
      method: 'get',
      params
    })
  },
  // 获取Excel下载
  getLiveExportExcel: (params: any) => {
    return request({
      url: baseURL + 'cggl/exportExcel',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  // 受理人-获取我的订单
  getMyOrderList: (params: any) =>
    request({
      url: baseURL + 'cggl/ticket/waiter/list',
      method: 'get',
      params
    })
}

export const CGGLISAUDIAPI = {
  // 首页dashboard数据
  getDashboardWaiterData: (params: any) => {
    return request({
      url: baseURL + 'cggl/waiter/dashboard',
      method: 'get',
      params
    })
  },
  // 获取基地工单统计
  getAreaAudit: (params: any) => {
    return request({
      url: baseURL + 'cggl/place/audit',
      method: 'get',
      params
    })
  },
  // 获取个人发起统计数据
  getMyAudit: (params: any) => {
    return request({
      url: baseURL + 'cggl/ticket/my/audit',
      method: 'get',
      params
    })
  },
  // 获取系统SLA统计数据
  getSystemSLAData: (params: any) => {
    return request({
      url: baseURL + 'cggl/systemSLA',
      method: 'get',
      params
    })
  },
  // 获取所有工单统计
  getAllAudit: (params: any) => {
    return request({
      url: baseURL + 'cggl/all/audit',
      method: 'get',
      params
    })
  },
  // 获取个人工单统计
  getOwnAudit: (params: any) => {
    return request({
      url: baseURL + 'cggl/waiter/audit',
      method: 'get',
      params
    })
  }
}
